const menuItems = [
  {
    label: 'All media',
    route: '/home'
  },
  {
    label: 'My media',
    route: '/my-media'
  },
  {
    label: 'Categories',
    route: '/home',
    subs: [
      {
        label: 'Graphics',
        route: '/search?filter[type]=graphic',
      },
      {
        label: 'Videos',
        route: '/search?filter[type]=video',
      },
      {
        label: 'Collections',
        route: '/collections'
      },
      {
        label: 'Social Media',
        route: '/search?filter[type]=social-media',
      },
      {
        label: 'Photos',
        route: '/search?filter[type]=photo',
      },
      {
        label: 'Sermon Kits',
        route: '/search?filter[type]=sermon-kit',
      },
      {
        label: 'Favorites',
        route: '/favorites?filter[type]=all',
      },
    ]
  },
]

export default menuItems
